export default "__VITE_ASSET__BxtvV4kQ__"